import React, { Component } from 'react';
import PrimaryButtonGE from 'src/Components/PrimaryButtonGE/PrimaryButtonGE';
import {getProfileDetails} from 'src/Actions/Profile/profileActions';
import unlocked from 'src/Assets/Images/Unlocked.svg';
import { connect } from 'react-redux';
import { updateAdminTerms } from 'src/Actions/Registration/registerActions';
import { withRouter } from 'react-router-dom';
import { AnalyticsService } from 'src/Analytics/AnalyticsService';
import { filterActiveStatus } from 'src/Utils/index';
import './styles.scss';
import { withTranslation } from 'react-i18next';

class AdminAcknowledge extends Component {
  constructor(props) {
    super(props);
    
  }

  componentDidMount() {
    
    this.props.getProfileDetails();
    
    this.updateAnalytics();
  }

  updateAnalytics = () => {
    const category = window.location.href.replace(window.location.origin, '');
    const digitalData = {
      page: {
        pageInfo: {
          domain: document.domain,
          location: document.location,
          pageName: 'Admin Acknowledge',
          siteSection: 'Admin Acknowledge',
          pageURL: document.URL,
        },
        category: {
          primaryCategory: category.replace('/', ''),
          pageType: document.domain,
        },
      },
      user: {
        profile: {
          profileInfo: {
            loginStatus: 'logged in',
            profileID: this.props.subscription?.subscriptionInfo?.sfdcUserId,
          },
        },
      },
    };

    AnalyticsService.updateDigitalData(digitalData);
    AnalyticsService.trackEvent('setAnalyticsVariables');
    AnalyticsService.trackEvent('pageLoaded');
  };

  componentDidUpdate(prevProps) {
    const { registration } = this.props;
    if (prevProps.registration !== registration && registration?.updateDetails?.toLowerCase().includes('success')) {
        const { subscriptionInfo } = this.props.subscription;
        const { userSubscriptionInfo } = subscriptionInfo;
        let { formattedActiveEduList, formattedActiveCollabList } =
          filterActiveStatus(userSubscriptionInfo);
        let isEducationActive;
        if(formattedActiveEduList?.length > 0) isEducationActive = true;
        else isEducationActive = false;

        let isCollaborationActive;
        if(formattedActiveCollabList?.length > 0) isCollaborationActive = true;
        else isCollaborationActive = false;
        
        if (isEducationActive || isCollaborationActive) {
          this.props.history.push('/people');
        }
        else {
          this.props.history.push('/info');
        }
      // }
    }
  }

  handleAcceptTerms = () => {
    let { adminAccounts } =
      this.props.registration && this.props.registration.accountStatus;

    adminAccounts.map((account) => {
      account.adminAccepted = true;
    });

    window.digitalData.link = {
      linkName: 'I Accept Terms',
      linkType: 'I Accept Terms',
    };

    AnalyticsService.trackEvent('link_click');
    this.props.updateAdminTerms(adminAccounts);
  };

  render() {
    let { adminAccounts } =
    this.props.registration && this.props.registration.accountStatus;
    const {t} = this.props;
    const facilities =
      adminAccounts && adminAccounts.map((acc) => acc.facilityName);
    const uniqArr = facilities.reduce(function (previous, current) {
      const object = previous.filter((obj) => obj.id === current.id);
      if (object.length == 0) {
        previous.push(current);
      }
      return previous;
    }, []);

    return (
      <div className="admin-ack-container">
        {this.props.profile.fieldValue.language && <div className="content">
          <div className="round-bg">
            <img src={unlocked} />
          </div>
          <div className="admin-title-wrapper">{t('headerText')}</div>
          <div className="admin-sub-wrapper">
            {t('descriptionFirstText')}
            {uniqArr &&
              uniqArr.map((account) => (
                <>
                  <br />
                  <span style={{ fontWeight: 'bold' }} key={account}>
                    {account}
                  </span>
                </>
              ))}
          </div>

          <div className="admin-sub-wrapper-paragraph">{t('paragraphText')}</div>
          <PrimaryButtonGE
            className="accept-button"  
            text={t('acceptText')}
            onClick={this.handleAcceptTerms}
          />
        </div>}
      </div>
    );
  }
}

export const mapStateToProps = ({
  profile, registration,
  collab,
  subscription,
}) => ({
  profile, registration,
  collab,
  subscription,
});

const mapDispatchToProps = (dispatch) => ({
  getProfileDetails: () => dispatch(getProfileDetails()),
  updateAdminTerms: (payload) => dispatch(updateAdminTerms(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(AdminAcknowledge)));
